import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InputGroup, InputGroupAddon, Button, Input, Alert } from 'reactstrap';
import { isApartamentoValid } from '../../utils/validation';

import actions from './actions';
import  { PERFIS_CONHECIDOS } from './constants';

const UNIDADE = ['morador', 'proprietario'];

class FormularioAcesso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      success: false,
      errors: [],
      data: {
        roles: [],
        unidades: '',
        observacao: ''
      }
    };

    this.solicita = this.solicita.bind(this);
  }

  isSelected(...v) {
    return v.some(v => -1 < this.state.data.roles.indexOf(v));
  }

  handlePerfil(e) {
    this.setState({
      success: false,
      data: {
        ...this.state.data,
        roles: Array.from(e.target.options)
          .filter(v => v.selected)
          .map(v => v.value)
      }
    });
  }

  handle(field, sanitize = /[^\d\w\sáéíóúàâêôãõç]+/gi) {
    let _this = this;
    return function(e) {
      let value = e.target.value;
      if (e.target.valueAsNumber || !e.target.value) {
        value = e.target.value;
      }

      _this.setState({
        data: {
          ..._this.state.data,
          [field]: value
            .replace(/^\s+|\s+(?=\s$|\s)/g, '')
            .replace(sanitize, '')
        }
      });
    };
  }

  isValid () {
    let { roles, unidades } = this.state.data;

    let errors = [];
    if (!roles.filter(v => ~PERFIS_CONHECIDOS.indexOf(v)).length) {
      errors.push('Perfis de acesso inválido');
    }
    if (unidades) {
      if (!unidades.split(/\W/g).every(v => isApartamentoValid(v))) {
        errors.push('Unidades inválidas');
      }
    } else if (roles.some(v => -1 < UNIDADE.indexOf(v))) {
      errors.push('Necessário informar unidade');
    }

    return errors;
  }

  validate () {
    let errors = this.isValid();
    if (errors.length || this.state.errors.length) {
      this.setState({
        errors
      });
    }

    return !errors.length;
  }

  solicita(e) {
    e.preventDefault();

    if (this.validate()) {
      this.setState({
        fetching: true,
        success: false
      });
      this.props.actions.onSolicitaAcesso(this.state.data).then(() => {
        this.setState({
          fetching: false,
          success: true,
          errors: [],
          data: {
            roles: [],
            unidades: ''
          }
        });
      });
    }
  }

  render() {
    let { data, errors, fetching, success } = this.state;

    let isUnidade = this.isSelected('morador', 'proprietario');

    return (
      <form onSubmit={this.solicita}>
        {!success && <Alert color="warning" isOpen={isUnidade}>
          Se for proprietário de mais de uma unidade, separe-as por vírgula
          no campo "Unidade(s)".
        </Alert>}
        <InputGroup>
          <InputGroupAddon
            addonType="prepend"
            className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
          >
            Perfil
          </InputGroupAddon>
          <Input
            disabled={fetching}
            onChange={e => this.handlePerfil(e)}
            type="select"
            multiple
            size="12"
            title="Perfil do usuário"
            required
            value={data.roles}
          >
            {[
              ['Administração', ['conselheiro', 'sindico']],
              ['Serviço', ['porteiro', 'zelador']],
              ['Unidade', ['morador', 'proprietario']],
              ['Externo', ['agua-mineral']]
            ].map((v, i) => (
              <optgroup key={i} label={v[0]}>
                {v[1].map((v, i) => (
                  <option key={i} value={v}>» {v}</option>
                ))}
              </optgroup>
            ))}
          </Input>
        </InputGroup>
        {isUnidade && (
          <InputGroup>
            <InputGroupAddon
              addonType="prepend"
              className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
            >
              Unidade(s)
            </InputGroupAddon>
            <Input
              disabled={fetching}
              placeholder="Unidade(s)"
              title="Número do apartamento"
              value={data.unidades}
              onChange={this.handle('unidades', /[^\d,]+/gi)}
            />
          </InputGroup>
        )}
        <InputGroup>
          <InputGroupAddon
            addonType="prepend"
            className="d-none d-sm-block col-sm-4 col-md-3 col-xl-2"
          >
            Observação
          </InputGroupAddon>
          <Input
            disabled={fetching}
            placeholder="Observação"
            type="textarea"
            value={data.observacao}
            onChange={this.handle('observacao')}
          />
          <InputGroupAddon addonType="append">
            <Button disabled={fetching || !!this.isValid().length} type="submit" color="success" title="Solicitar!">
              <span className="fa fa-check" />{' '}
              <span className="d-none d-md-inline-block">Solicitar!</span>
            </Button>
          </InputGroupAddon>
        </InputGroup>
        <br />
        <Alert isOpen={success}>Solicitação realizada com sucesso.</Alert>
        {errors.map((v, i) => (<Alert color="danger" key={i}>{v}</Alert>))}
      </form>
    );
  }
}

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(FormularioAcesso);



// WEBPACK FOOTER //
// ./src/modules/auth/FormularioAcesso.js